
import {ref, defineComponent, PropType} from 'vue';

interface Tab {
  name: string;
  label: string;
}

export default defineComponent({
  name: 'TabContainer',
  props: {
    tabs: {
      type: Array as PropType<Tab[]>,
      required: true,
    },
    defaultActive: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const activeTab = ref<number>(props.defaultActive);

    return {
      activeTab,
    };
  },
});
